import { animate, style, transition, trigger } from '@angular/animations';

export const slideInOut = trigger('slideInOut', [
  transition(':enter', [
    style({
      bottom: '0px',
      opacity: 0,
    }),
    animate(
      '200ms ease-out',
      style({
        bottom: '80px',
        opacity: 1,
      })
    ),
  ]),
  transition(':leave', [
    animate(
      '200ms ease-in',
      style({
        bottom: '0px',
        opacity: 0,
      })
    ),
  ]),
]);
